module.exports = __webpack_public_path__ + "img/1049653816.c514a438.png";